import type { IconList } from "services/cms/models";
import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";

export interface ResolvedIconUl {
    html: string;
    type: ContentTypeCodenames.IconList;
    codename: string;
}

const iconUlResolver = (data: IconList): ResolvedIconUl => {
    return {
        html: data.elements.list.value,
        type: ContentTypeCodenames.IconList,
        codename: data.system.codename,
    };
};

export default iconUlResolver;
